import React from "react";

import TickList from "../tick-list/TickList";
import ClockIcon from "@/assets/icons/clock-icon.svg";
import styles from "./index.module.scss";

const listItems = [
  "Return unwanted items from the delivery up to 30 days after purchase. <a href='https://www.johnlewis.com/customer-services/returns/how-do-i-return-an-item'>Find out how to make a return</a>",
  "Leave Click & Collect orders at the shop. They will be sent back to us after 7 days automatically and you’ll be refunded",
];

function CancelOrder() {
  return (
    <div>
      <section>
        <img src={ClockIcon.src} alt="" className={styles.clockIcon} />
        <h2>You have a short time to cancel</h2>
        <p>You may be able to cancel depending on the status of your order.</p>
        <p>
          To check, sign in to <a href="https://account.johnlewis.com/orders">My Account</a> or view the order details
          from your order confirmation email. If the option to cancel is available, it will appear under ‘Change your
          order’ in dropdown menu.
        </p>
      </section>
      <section>
        <h2>Can’t cancel your order?</h2>
        <p>
          If the option doesn’t appear, unfortunately it’s too late to cancel and your order will be delivered as
          scheduled.
        </p>
        <p>If unwanted items are delivered, you can:</p>
        <TickList items={listItems} />
      </section>
    </div>
  );
}

export default CancelOrder;
